export interface ITermsOfUse {
    id: string;
    date: number;
    url: string;
    expirationDate: number;
    acceptances: {
        [user: string]: {
            accepted: boolean;
            date: number;
        }
    }
}

export enum TermsOfUseUserStatus {
    AgreeUser = 'AgreeUser',
    LaterUser = 'LaterUser',
    ExpiredUser = 'ExpiredUser',
    Initial = 'Initial',
	NoRecords = 'NoRecords'
}